import { useLocation } from 'react-router-dom';

export const useQuery = (queryString: string): string | null => {
  return new URLSearchParams(useLocation().search).get(queryString);
};
